<template>
    <div>
      <h4>teste 3</h4>

      <h5>{{ testeGeoJson }}</h5>

      <button @click="clickTeste2">Teste 2</button>

      <div v-for="(poligono, key) in poligonos"  >
        <p>tem aqui {{ key }}</p>
        <button @click="clickTeste(poligono)">pegar json</button>
      </div>

    <input id="save" value="save" type="button" @click="clickSave" />
    <input type="button" @click="clickTeste" />
    <div id="geojson"></div>
    <div id="map"></div>

    <form>
      <label for="address">Endereço:</label>
      <input type="text" id="address" v-model="address" @input="autocompleteAddress" placeholder="Digite o endereço...">
      <button type="button" class="btn btn-primary"  @click="getCurrentLocation()">Pegar minha localização!</button>
      <div v-if="showSuggestions">
        <ul>
          <li v-for="suggestion in suggestions" :key="suggestion.place_id" @click="selectAddress(suggestion)">
            {{ suggestion.description }}
          </li>
        </ul>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      map: null,
      address: '',
      geocoder: null,
      dataLayer: null,
      autocompleteService: null,
      suggestions: [],
      showSuggestions: false,
      marker: null,
      poligonos: [],
      testeGeoJson:null,
      endereco: {
        cep: "",
        pais: "",
        estado: "",
        cidade: "",
        bairro: "",
        rua: "",
      },
      neighborhoodPolygon: null,
      editablePolygon: null
    };
  },

  mounted() {
    this.initMap();
    this.geocoder = new google.maps.Geocoder();

    this.dataLayer = new google.maps.Data();
    this.autocompleteService = new google.maps.places.AutocompleteService();
    this.getCurrentLocation();

    this.inserirBairro();

  },

  methods: {
    //Iniciar Mapa
    initMap() {
      this.map = new google.maps.Map(document.getElementById("map"), {
        zoom: 15,
        center: { lat: -34.397, lng: 150.644 },
        mapId: "DEMO_MAP_ID",
      });

      this.initDrawing(this.map);
    },

    initDrawing(map) {
        let drawingManager = new google.maps.drawing.DrawingManager({
            map,
            drawingControl: true,

            polygonOptions: {
                fillColor: '#f00',
                editable: true,
            }

        });

        google.maps.event.addListener(drawingManager, 'polygoncomplete', (polygon) => {

          // const novo_poligono = new google.maps.Polygon({
          //   paths: polygon.getPath(),
          //   strokeColor: "#FF0000",
          //   strokeOpacity: 0.8,
          //   strokeWeight: 3,
          //   fillColor: "#FF0000",
          //   fillOpacity: 0.35,
          // });

          // novo_poligono.setMap(map);

          this.poligonos.push(polygon);

          // this.dataLayer.add(new google.maps.Data.Feature({
          //   geometry: new google.maps.Data.Polygon([polygon.getPath().getArray()])
          // }));
        });


    },

    clickSave(){
      this.dataLayer.toGeoJson(function(obj) {
        document.getElementById('geojson').innerHTML = JSON.stringify(obj);
      });
    },

    clickTeste(obj){

      this.testeGeoJson = this.googleMapsPolygonToGeoJsonFeature(obj);

    },

    clickTeste2(){

        this.testeGeoJson = this.googleMapsPolygonToGeoJsonFeature(this.editablePolygon);

    },

    converterPoligonoEmGeoJson(polygon){

      var dataLayer = new google.maps.Data();

      dataLayer.add(new google.maps.Data.Feature({
        geometry: new google.maps.Data.Polygon([polygon.getPath().getArray()])
      }));

      dataLayer.toGeoJson(function(obj) {
        this.testeGeoJson = obj;
      });

    },

    googleMapsPolygonToGeoJsonFeature(polygon) {
      const geometry = {
        type: "Polygon",
        coordinates: [],
      };

      const coords = polygon
        .getPath()
        .getArray()
        .map((el) => {
          return [el.lng(), el.lat()];
        });

      geometry.coordinates = [coords];

      const feature = {
        geometry,
        type: "Feature",
        properties: {},
      };

      return feature;
    },

    pesquisarbairro(neighborhoodName) {

      this.geocoder.geocode({ address: neighborhoodName }, (results, status) => {
        if (status === "OK") {
          const bounds = results[0].geometry.bounds;
          const northEast = bounds.getNorthEast();
          const southWest = bounds.getSouthWest();

          const coordinates = [
            { lat: northEast.lat(), lng: northEast.lng() },
            { lat: northEast.lat(), lng: southWest.lng() },
            { lat: southWest.lat(), lng: southWest.lng() },
            { lat: southWest.lat(), lng: northEast.lng() },
          ];

          // Remover o polígono anterior, se houver
          if (this.neighborhoodPolygon) {
            this.neighborhoodPolygon.setMap(null);
          }

          // Desenhar o novo polígono
          this.neighborhoodPolygon = new google.maps.Polygon({
            paths: coordinates,
            strokeColor: "#FF0000",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: "#FF0000",
            fillOpacity: 0.35,
          });

          this.neighborhoodPolygon.setMap(this.map);

          // Ajustar o mapa para o polígono
          this.map.fitBounds(bounds);
        } else {
          alert("Geocode was not successful for the following reason: " + status);
        }
      });

    },

    importaGeojson(){
      const geoJsonData  = {
        "type": "FeatureCollection",
        "features": [
          {
            "type": "Feature",
            "properties": {},
            "geometry": {
              "coordinates": [
                [
                  [
                    -34.82924943719058,
                    -7.878727578178001
                  ],
                  [
                    -34.83309751222413,
                    -7.879557346235899
                  ],
                  [
                    -34.83969421228201,
                    -7.886662167134148
                  ],
                  [
                    -34.838280633698076,
                    -7.891018347338502
                  ],
                  [
                    -34.83173628840294,
                    -7.891822161287763
                  ],
                  [
                    -34.824066315716664,
                    -7.891744372909912
                  ],
                  [
                    -34.82427573476593,
                    -7.886428799041866
                  ],
                  [
                    -34.8256893133499,
                    -7.882643031610726
                  ],
                  [
                    -34.82731231098313,
                    -7.880024090038091
                  ],
                  [
                    -34.82924943719058,
                    -7.878727578178001
                  ]
                ]
              ],
              "type": "Polygon"
            }
          },
          {
            "type": "Feature",
            "properties": {},
            "geometry": {
              "coordinates": [
                [
                  [
                    -34.827047446105894,
                    -7.892376235690747
                  ],
                  [
                    -34.83580681653251,
                    -7.892637835590406
                  ],
                  [
                    -34.83624698590111,
                    -7.898523789547795
                  ],
                  [
                    -34.828720089704916,
                    -7.89887258418679
                  ],
                  [
                    -34.827047446105894,
                    -7.892376235690747
                  ]
                ]
              ],
              "type": "Polygon"
            }
          }
        ]
      };

      // Adicionar os dados GeoJSON ao mapa
      this.map.data.addGeoJson(geoJsonData);


      // Ajustar o mapa para o polígono
      const bounds = new google.maps.LatLngBounds();

      this.map.data.forEach((feature) => {
          feature.getGeometry().forEachLatLng((latlng) => {
            bounds.extend(latlng);
          });
        });

        this.map.fitBounds(bounds);

    },

    inserirBairro(){

        const geoJsonData  = {
            "type": "FeatureCollection",
            "features": [
                {
                "type": "Feature",
                "properties": {},
                "geometry": {
                    "coordinates": [
                    [
                        [
                        -34.82924943719058,
                        -7.878727578178001
                        ],
                        [
                        -34.83309751222413,
                        -7.879557346235899
                        ],
                        [
                        -34.83969421228201,
                        -7.886662167134148
                        ],
                        [
                        -34.838280633698076,
                        -7.891018347338502
                        ],
                        [
                        -34.83173628840294,
                        -7.891822161287763
                        ],
                        [
                        -34.824066315716664,
                        -7.891744372909912
                        ],
                        [
                        -34.82427573476593,
                        -7.886428799041866
                        ],
                        [
                        -34.8256893133499,
                        -7.882643031610726
                        ],
                        [
                        -34.82731231098313,
                        -7.880024090038091
                        ],
                        [
                        -34.82924943719058,
                        -7.878727578178001
                        ]
                    ]
                    ],
                    "type": "Polygon"
                }
                },
                {
                "type": "Feature",
                "properties": {},
                "geometry": {
                    "coordinates": [
                    [
                        [
                        -34.827047446105894,
                        -7.892376235690747
                        ],
                        [
                        -34.83580681653251,
                        -7.892637835590406
                        ],
                        [
                        -34.83624698590111,
                        -7.898523789547795
                        ],
                        [
                        -34.828720089704916,
                        -7.89887258418679
                        ],
                        [
                        -34.827047446105894,
                        -7.892376235690747
                        ]
                    ]
                    ],
                    "type": "Polygon"
                }
                }
            ]
        };

        let drawingManager;

        // Converter coordenadas GeoJSON para um array de google.maps.LatLng
        const coordinates = geoJsonData.features[0].geometry.coordinates[0].map(coord => ({ lat: coord[1], lng: coord[0] }));

        // Criar o polígono a partir dos dados GeoJSON
        this.editablePolygon = new google.maps.Polygon({
          paths: coordinates,
          strokeColor: "#FF0000",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#FF0000",
          fillOpacity: 0.35,
          editable: true,
          draggable: true
        });

        this.editablePolygon.setMap(this.map);

        // Ajustar o mapa para o polígono
        const bounds = new google.maps.LatLngBounds();

        coordinates.forEach((latlng) => {
          bounds.extend(latlng);
        });

        this.map.fitBounds(bounds);

        // Adicionar o DrawingManager ao mapa
        drawingManager = new google.maps.drawing.DrawingManager({
          drawingMode: google.maps.drawing.OverlayType.POLYGON,
          drawingControl: true,
          drawingControlOptions: {
            position: google.maps.ControlPosition.TOP_CENTER,
            drawingModes: ['polygon']
          },
          polygonOptions: {
            editable: true,
            draggable: true
          }
        });

        drawingManager.setMap(this.map);

        // Evento para capturar o novo polígono desenhado
        google.maps.event.addListener(drawingManager, 'overlaycomplete', function(event) {
          if (event.type === google.maps.drawing.OverlayType.POLYGON) {
            // Remover o polígono anterior
            if (this.editablePolygon) {
                this.editablePolygon.setMap(null);
            }

            // Tornar o novo polígono editável
            this.editablePolygon = event.overlay;
            this.editablePolygon.setEditable(true);
          }
        });




    },


    //Alterar a posição do marcador manualmente
    handleMarkerDrag() {
        console.log("entrou");
      const newPosition = this.marker.getPosition();
      console.log('Nova posição:', newPosition.lat(), newPosition.lng());
      // Aqui você pode realizar qualquer ação com a nova posição do marcador
    },
    //Pega a localização atual
    getCurrentLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          const pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          this.map.setCenter(pos);
          this.marker = new google.maps.Marker({
            position: pos,
            map: this.map,
            draggable: true,
            title: "Sua localização atual",
          });
          this.getAddressFromCoordinates(pos.lat, pos.lng);

          google.maps.event.addListener(this.marker, 'dragend', () => {
                this.handleMarkerDrag();
            });
        });
      }
    },
    //Pega o endereço pelas coodernadas fornecidas
    getAddressFromCoordinates(lat, lng) {
      const latlng = { lat, lng };
      this.geocoder.geocode({ location: latlng }, (results, status) => {
        if (status === "OK") {
          if (results[0]) {
            this.address = results[0].formatted_address;
            this.preecherEndereco(results);
          } else {
            console.error("Nenhum resultado encontrado");
          }
        } else {
          console.error("Geocoder falhou devido a: " + status);
        }
      });
    },
    //Autocomplete
    autocompleteAddress() {
      if (this.address === '') {
        this.showSuggestions = false;
        return;
      }

      this.autocompleteService.getPlacePredictions({ input: this.address, region: "br", types: ['sublocality'] }, (predictions, status) => {
        if (status === 'OK') {
          this.suggestions = predictions;
          this.showSuggestions = true;
        } else {
          console.error("Autocomplete falhou devido a: " + status);
        }
      });
    },

    preecherEndereco(results) {

        results[0].address_components.forEach(element => {

            element.types.forEach(element2 => {
                switch (element2) {
                    case 'route':
                        this.endereco.rua = element.long_name;
                        break;
                    case 'sublocality':
                        this.endereco.bairro = element.long_name;
                        break;
                    case 'administrative_area_level_2':
                        this.endereco.cidade = element.long_name;
                        break;
                    case 'administrative_area_level_1':
                        this.endereco.estado = element.long_name;
                        break;
                    case 'country':
                        this.endereco.pais = element.long_name;
                        break;
                    case 'postal_code':
                        this.endereco.cep = element.long_name;
                        break;

                    default:
                        break;
                }
            });

          });

    },

    //Seleciona um endereço da lista de sugestões
    selectAddress(suggestion) {
      this.address = suggestion.description;
      this.showSuggestions = false;

      // Use Geocodificação para obter coordenadas do endereço selecionado e atualizar o mapa
      this.geocoder.geocode({ placeId: suggestion.place_id }, (results, status) => {
        if (status === 'OK') {

          this.preecherEndereco(results);

          const location = results[0].geometry.location;
          this.map.setCenter(location);
          new google.maps.Marker({
            position: location,
            map: this.map,
            title: suggestion.description,
          });
        } else {
          console.error("Geocoder falhou devido a: " + status);
        }
      });
    },



  },
};
</script>

<style>
#map {
  height: 400px;
  width: 100%;
}
</style>
